import { Injectable } from '@angular/core';

export interface SubcategoryImage {
  src: string;
  alt: string;
  width?: number;
  height?: number;
  className?: string;
}

@Injectable({
  providedIn: 'root',
})
export class SubcategoryImagesService {
  private subcategoryImages: { [key: string]: SubcategoryImage } = {
    automobile: {
      src: 'assets/images/subcategoriesIcon/automobile.png',
      alt: 'Automobile',
      width: 180,
      height: 180,
    },
    motorcycle: {
      src: 'assets/images/subcategoriesIcon/motorcycle.png',
      alt: 'Motorcycle',
      width: 180,
      height: 180,
    },
    'commercial-vehicles': {
      src: 'assets/images/subcategoriesIcon/commercial-vehicles.png',
      alt: 'Commercial Vehicles',
      width: 180,
      height: 180,
    },
    oldtimer: {
      src: 'assets/images/subcategoriesIcon/oldtimer.png',
      alt: 'Oldtimer',
      width: 180,
      height: 180,
    },
    nautical: {
      src: 'assets/images/subcategoriesIcon/nautical.png',
      alt: 'Nautical',
      width: 180,
      height: 180,
    },
    'spare-parts': {
      src: 'assets/images/subcategoriesIcon/spare-parts.png',
      alt: 'Spare Parts & Equipment',
      width: 180,
      height: 180,
    },
    'campers-caravans': {
      src: 'assets/images/subcategoriesIcon/campers-caravans.png',
      alt: 'Campers & Caravans',
      width: 180,
      height: 180,
    },
    'crashed-cars': {
      src: 'assets/images/subcategoriesIcon/crashed-cars.png',
      alt: 'Crashed Cars',
      width: 180,
      height: 180,
    },
    'construction': {
      src: 'assets/images/subcategoriesIcon/construction.png',
      alt: 'Construction',
      width: 180,
      height: 180,
    },
    'agriculture': {
      src: 'assets/images/subcategoriesIcon/agriculture.png',
      alt: 'Agriculture',
      width: 180,
      height: 180,
    },
    'house-sale': {
      src: 'assets/images/subcategoriesIcon/house-sale.png',
      alt: 'House Sale',
      width: 180,
      height: 180,
    },
    'house-rent': {
      src: 'assets/images/subcategoriesIcon/house-rent.png',
      alt: 'House Rent',
      width: 180,
      height: 180,
    },
    'apartments-sale': {
      src: 'assets/images/subcategoriesIcon/apartments-sale.png',
      alt: 'Apartments Sale',
      width: 180,
      height: 180,
    },
    'apartments-rent': {
      src: 'assets/images/subcategoriesIcon/apartmentsforrent.png',
      alt: 'Apartments Rent',
      width: 180,
      height: 180,
    },
    'land-sale': {
      src: 'assets/images/subcategoriesIcon/land-sale.png',
      alt: 'Land Sale',
      width: 180,
      height: 180,
    },
    'land-rent': {
      src: 'assets/images/subcategoriesIcon/land-rent.png',
      alt: 'Land Rent',
      width: 180,
      height: 180,
    },
    'business-office-sale': {
      src: 'assets/images/subcategoriesIcon/business-office-sale.png',
      alt: 'Business Office Sale',
      width: 180,
      height: 180,
    },
    'business-office-rent': {
      src: 'assets/images/subcategoriesIcon/business-office-rent.png',
      alt: 'Business Office Rent',
      width: 180,
      height: 180,
    },
    'garage-sale': {
      src: 'assets/images/subcategoriesIcon/garagesale.png',
      alt: 'Garage Sale',
      width: 180,
      height: 180,
    },
    'garage-rent': {
      src: 'assets/images/subcategoriesIcon/garagerent.png',
      alt: 'Garage Rent',
      width: 180,
      height: 180,
    },
    'luxury-real-estate-sale': {
      src: 'assets/images/subcategoriesIcon/luxurysale.png',
      alt: 'Luxury Real Estate Sale',
      width: 180,
      height: 180,
    },
    'luxury-real-estate-rent': {
      src: 'assets/images/subcategoriesIcon/luxuryrent.png',
      alt: 'Luxury Real Estate Rent',
      width: 180,
      height: 180,
    },
    'room-rent': {
      src: 'assets/images/subcategoriesIcon/roomrent.png',
      alt: 'Room Rent',
      width: 180,
      height: 180,
    },
    'looking-for-roommate': {
      src: 'assets/images/subcategoriesIcon/roommate.png',
      alt: 'Looking for Roommate',
      width: 180,
      height: 180,
    },
    home: {
      src: 'assets/images/subcategoriesIcon/home.png',
      alt: 'Home',
      width: 180,
      height: 180,
    },
    electronics: {
      src: 'assets/images/subcategoriesIcon/electronics.png',
      alt: 'Electronics',
      width: 180,
      height: 180,
    },
    sport: {
      src: 'assets/images/subcategoriesIcon/sport.png',
      alt: 'Sport',
      width: 180,
      height: 180,
    },
    children: {
      src: 'assets/images/subcategoriesIcon/children.png',
      alt: 'Children',
      width: 180,
      height: 180,
    },
    'head-to-toe': {
      src: 'assets/images/subcategoriesIcon/headtotoe.png',
      alt: 'Head to Toe',
      width: 180,
      height: 180,
    },
    'machines-tools': {
      src: 'assets/images/subcategoriesIcon/machinestools.png',
      alt: 'Machines & Tools',
      width: 180,
      height: 180,
    },
    media: {
      src: 'assets/images/subcategoriesIcon/media.png',
      alt: 'Media',
      width: 180,
      height: 180,
    },
    'musical-instruments': {
      src: 'assets/images/subcategoriesIcon/musical.png',
      alt: 'Musical Instruments',
      width: 180,
      height: 180,
    },
    literature: {
      src: 'assets/images/subcategoriesIcon/literature.png',
      alt: 'Literature',
      width: 180,
      height: 180,
    },
    pets: {
      src: 'assets/images/subcategoriesIcon/pets.png',
      alt: 'Pets',
      width: 180,
      height: 180,
    },
    other: {
      src: 'assets/images/subcategoriesIcon/other.png',
      alt: 'Other',
      width: 180,
      height: 180,
    },
    'giving-away': {
      src: 'assets/images/subcategoriesIcon/giving-away.png',
      alt: 'Giving Away',
      width: 180,
      height: 180,
    },
    professional: {
      src: 'assets/images/subcategoriesIcon/professional.png',
      alt: 'Professional',
      width: 180,
      height: 180,
    },
    'home-maintenance': {
      src: 'assets/images/subcategoriesIcon/homemaintenance.png',
      alt: 'Home Maintenance',
      width: 180,
      height: 180,
    },
    'personal-care-wellness': {
      src: 'assets/images/subcategoriesIcon/personalcare.png',
      alt: 'Personal Care & Wellness',
      width: 180,
      height: 180,
    },
    'events-entertainment': {
      src: 'assets/images/subcategoriesIcon/eventsentertainment.png',
      alt: 'Events & Entertainment',
      width: 180,
      height: 180,
    },
    'education-training': {
      src: 'assets/images/subcategoriesIcon/edutraining.png',
      alt: 'Education & Training',
      width: 180,
      height: 180,
    },
    'transport-delivery': {
      src: 'assets/images/subcategoriesIcon/transportdelivery.png',
      alt: 'Transport & Delivery',
      width: 180,
      height: 180,
    },
  };

  private defaultImage: SubcategoryImage = {
    src: 'assets/images/listing-placeholder/no-image-placeholder.png',
    alt: 'Category',
    width: 180,
    height: 180,
  };

  getSubcategoryImage(slug: string): SubcategoryImage {
    return this.subcategoryImages[slug] || this.defaultImage;
  }

  hasImage(slug: string): boolean {
    return !!this.subcategoryImages[slug];
  }

  addSubcategoryImage(slug: string, image: SubcategoryImage): void {
    this.subcategoryImages[slug] = image;
  }

  getAvailableSubcategories(): string[] {
    return Object.keys(this.subcategoryImages);
  }
}
